import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AuthLayoutComponent } from '../../../layouts/auth-layout/auth-layout.component';
import { AnchorComponent } from '../../../shared/components/anchor/anchor.component';
import { AuthRoutingModule } from './auth-routing.module';
import { OpenidAuthenticationComponent } from './components/openid-authentication/openid-authentication.component';
import { ForgetPasswordComponent } from './pages/forget-password/forget-password.component';
import { LoginComponent } from './pages/login/login.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { VerifyEmailComponent } from './pages/verify-email/verify-email.component';

@NgModule({
  declarations: [],
  imports: [
    ForgetPasswordComponent,
    SignUpComponent,
    VerifyEmailComponent,

    CommonModule,
    AuthLayoutComponent,
    AuthRoutingModule,
    LoginComponent,
    OpenidAuthenticationComponent,
    InlineSVGModule,
    AnchorComponent,
  ],
})
export class AuthModule {}
